import { io } from 'socket.io-client';
import actions from './redux/notifications/actions';

let socket;
const RECON_API_BASE_URL = process.env.REACT_APP_RECON_API_BASE_URL || 'https://uat-cou-recon-idfc.plutos.one/';

export const onLoginSuccess = (token, dispatch) => {
  socket = io(`${RECON_API_BASE_URL}`, {
    auth: {
      token: token,
      clientType: 'COUDashboard'
    }
  });

  socket.on('connect', () => {
    console.log('Connected to socket.io server');
  });

  setTimeout(() => {
    console.log('Is connected after 1s?', socket.connected);
  }, 2000);

  socket.on('file-processing', (data) => {
    // console.log('Received from server:', data.message);
    dispatch(actions.addNotification(`${data.message}`));
  });

  socket.on('file-ready', (data) => {
    // console.log('Received from server for Ready<<<>>>:', data.message);
    dispatch(actions.addNotification(`${data.message}`));
  });

  socket.on('connect_error', (err) => {
    console.error('❌ Socket connection error:');
  });

  socket.on('disconnect', () => {
    console.log('Socket disconnected');
  });

  // socket.onAny((event, ...args) => {
  //   console.log(`🔍 Event received: ${event}`, args);
  // });
};

export const disconnectSocket = () => {
  if (socket) socket.disconnect();
};

export const getSocket = () => socket;


